import { select, call, getContext, takeEvery } from 'redux-saga/effects';
import { DISABLE_FULLSTORY } from 'next/entities/features';
import { selectAccountFeature } from 'reducers/account/features';
import { selectUser } from 'reducers/user';
import {
  SEGMENT_CLONED,
  SEGMENT_DELETED,
  SEGMENT_CREATED_FROM_RULE,
  resolve,
} from 'actions/account/segments';
import { selectAccountSegments } from 'reducers/account/segments';

function* identify(payload) {
  const auth = yield getContext('auth');
  const isSpoofing = yield call(auth.isSpoofing);
  const isFullStoryDisabled = yield select(
    selectAccountFeature,
    DISABLE_FULLSTORY
  );
  const user = yield select(selectUser) || {};
  const userId = user.id;

  const options = {
    integrations: { FullStory: !isFullStoryDisabled },
  };
  if (window.analytics && window.analytics.identify && !isSpoofing) {
    window.analytics.identify(userId, payload, options);
  }
}

function* identifySegments() {
  const segments = yield select(selectAccountSegments);
  yield call(identify, { segments_count: Object.keys(segments || {}).length });
}

export default function* identifier() {
  yield takeEvery(
    [SEGMENT_CLONED, SEGMENT_DELETED, SEGMENT_CREATED_FROM_RULE, resolve],
    identifySegments
  );
}
